import React, { useRef, useState } from "react";

import { TimePicker as AntPicker } from "antd";

import { parseInputRules } from "utils";

import { Form, Icon, InputLabel } from "components";

export const TimePicker = ({
  className = "",
  format,
  initialValue,
  name,
  label,
  message,
  rules,
  showTime,
  disabledDate,
  disabled,
  showNow,
  onBlur = () => {},
  onChange = () => {},
}) => {
  const inputElement = useRef(null);
  const [hasBeenFocused, setHasBeenFocused] = useState(false);
  const [internalValue, setInternalValue] = useState(initialValue);

  const handleBlur = (...args) => {
    setHasBeenFocused(false);
    if (onBlur) {
      onBlur(...args);
    }
  };

  const handleChange = (...args) => {
    setInternalValue(args[0]);
    onChange(...args);
  };

  const handleLabelClick = () => {
    setHasBeenFocused(true);
    inputElement.current.focus();
  };

  const active = hasBeenFocused || internalValue;
  const required = rules && rules[0] && rules[0].required;

  return (
    <Form.Item
      className={`floating-input ${hasBeenFocused ? "active" : ""} ${disabled ? "disabled" : "message"} ${className}`}
      colon={false}
      label={<InputLabel active={active} required={required} label={label} handleClick={handleLabelClick} />}
      name={name}
      rules={parseInputRules(rules, message)}
      initialValue={initialValue}
    >
      <AntPicker
        allowClear={false}
        format={format || "DD.MM.YYYY"}
        open={hasBeenFocused}
        placeholder={initialValue || ""}
        ref={inputElement}
        showTime={showTime}
        disabledDate={disabledDate}
        onBlur={handleBlur}
        onChange={handleChange}
        onFocus={() => setHasBeenFocused(true)}
        disabled={disabled}
        showNow={showNow}
        suffixIcon={<Icon iconName="tabler/clock" />}
      />
    </Form.Item>
  );
};
